<template>
  <div class="party col-sm-4" :class="{'text-end': side === 'right'}">
    <div :class="'party-status-' + side + ((side === 'right')? ' float-end':' float-start')">
      <img
        v-if="side === 'left'"
        alt="party icon"
        :src="asset"
        class="party-status-img-left"
      />
      <strong>
        <slot></slot>  <!-- Party Name -->
      </strong>
      <img
        v-if="side === 'right'"
        alt="party icon"
        :src="asset"
        class="party-status-img-right"
      />
    </div>
  </div>
</template>

<script>
  const basePath = 'https://smartsettle-public.s3.ca-central-1.amazonaws.com/slider/2/'

  export default {
    name: "s-party",
    props: [
      'status',  // online, offline, etc.
      'side'     // left, right
    ],
    computed: {
      asset() {
        let onlineIconPath  = basePath + 'status-online.png'
        let offlineIconPath = basePath + 'status-offline.png'
        if (this.$root.options?.onlineIconPath && this.$root.options?.offlineIconPath) {
          onlineIconPath = this.$root.options.onlineIconPath
          offlineIconPath = this.$root.options.offlineIconPath
        }

        let isOnline = this.status === 'online'
        return isOnline ? onlineIconPath : offlineIconPath
      }
    },
  }
</script>

<style scoped>
  .party-status-left {
    padding-left: 30px;
    float: left;
  }
  .party-status-right {
    padding-right: 30px;
    float: left;
  }
</style>
